import React, { useState } from "react";
import { Box, IconButton } from "@material-ui/core";
import ColorizeIcon from "@material-ui/icons/Colorize";
import { ChromePicker } from "react-color";

export default function ColorPicker(props) {
  const { getValues, setValue, defaultValue, disabled } = props;
  const [colorHelper, setColorHelper] = useState({
    color: getValues("backgroundColor") || defaultValue,
    displayColorPicker: false,
  });

  return (
    <>
      <div
        style={{
          display: "inline-block",
          width: "107px",
          height: "40px",
          border: "1px solid #CCCCCC",
          background: `${getValues("backgroundColor") || defaultValue}`,
        }}
      ></div>

      <IconButton
        variant="outlined"
        style={{
          transform: "translateY(-15px)",
          height: "40px",
          width: "40px",
          padding: 0,
          borderRadius: "5px",
          border: "2px solid #CCCCCC",
        }}
        disabled={disabled}
        onClick={() =>
          setColorHelper({ ...colorHelper, displayColorPicker: true })
        }
      >
        <ColorizeIcon />
      </IconButton>

      {colorHelper.displayColorPicker ? (
        <div style={{ position: "absolute", zIndex: "2" }}>
          <div
            style={{
              position: "fixed",
              top: "0px",
              right: "0px",
              bottom: "0px",
              left: "0px",
            }}
            onClick={() =>
              setColorHelper({ ...colorHelper, displayColorPicker: false })
            }
          />
          <ChromePicker
            color={colorHelper.color}
            onChange={(color) => {
              setValue("backgroundColor", color.hex);
              setColorHelper({ ...colorHelper, color: color.hex });
            }}
          />
        </div>
      ) : null}
      <Box>
        <span
          style={{
            fontSize: "12px",
            color: "#CCCCCC",
            marginTop: 0,
            paddingTop: 0,
          }}
        >
          Default Colour: #000000
        </span>
        <div
          style={{
            display: "inline-block",
            border: "1px solid #CCCCCC",
            width: "14px",
            height: "14px",
            background: "#000000",
            marginLeft: "5px",
          }}
        ></div>
      </Box>
    </>
  );
}
